// src/webBilling.ts

const SMART_TIMING_WEB_PURCHASE_LINK =
  import.meta.env.VITE_RC_WEB_SMART_TIMING_URL || "";

type SmartTimingWebCheckoutArgs = {
  appUserId: string | number;
  email?: string | null;
};

export function buildSmartTimingWebPurchaseUrl({
  appUserId,
  email,
}: SmartTimingWebCheckoutArgs): string {
  if (!SMART_TIMING_WEB_PURCHASE_LINK) {
    throw new Error(
      "Smart Timing web checkout is not configured."
    );
  }

  if (appUserId === null || appUserId === undefined || appUserId === "") {
    throw new Error(
      "Your SatStacker account is still loading. Please try again."
    );
  }

  const base =
    SMART_TIMING_WEB_PURCHASE_LINK.replace(/\/+$/, "");

  /*
   * RevenueCat Web Purchase Links require an identified user's
   * App User ID as a PATH segment:
   *
   * https://pay.rev.cat/TOKEN/APP_USER_ID
   */
  const url = new URL(
    `${base}/${encodeURIComponent(String(appUserId))}`
  );

  // RevenueCat can pre-fill and lock the checkout email.
  if (email) {
    url.searchParams.set("email", email);
  }

  // Our RevenueCat web offering will contain the monthly package.
  url.searchParams.set("package_id", "$rc_monthly");

  /*
   * Skip RevenueCat's intermediate Purchase Complete screen.
   * RevenueCat will immediately use the custom success redirect
   * configured for the Purchase Link.
   */
  url.searchParams.set("skip_purchase_success", "true");

  return url.toString();
}